import type { MouseEventHandler } from "react";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import flow from "lodash/flow";

import { useEmailVerificationRequiredEventHandler } from "@src/hooks/useEmailVerificationRequiredEventHandler";
import { useLoginRequiredEventHandler } from "@src/hooks/useLoginRequiredEventHandler";

export const useAddFundsVerifiedLoginRequiredEventHandler = (): ((callback: MouseEventHandler) => MouseEventHandler) => {
  const intl = useIntl();
  const whenLoggedIn = useLoginRequiredEventHandler();
  const whenEmailIsVerified = useEmailVerificationRequiredEventHandler();

  return useCallback(
    (handler: MouseEventHandler) =>
      flow(
        whenEmailIsVerified(intl.formatMessage({ id: "hooks.addfundslogin.verifyemail", defaultMessage: "Verify your email to add funds to your balance." })),
        whenLoggedIn(intl.formatMessage({ id: "hooks.addfundslogin.signin", defaultMessage: "Sign In or Sign Up to add funds to your balance" }))
      )(handler),
    [whenEmailIsVerified, whenLoggedIn, intl]
  );
};
